/*
 * @Author: Chao Yang
 * @Date: 2020-07-22 03:25:24
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-07-25 21:42:50
 */

import { MyInvestmentProxy } from 'src/app/domain/proxy';
import { Observable, empty } from 'rxjs';
import { IAccount } from 'src/app/domain/model/dashboard';
import { IInvestment } from 'src/app/domain/model/dashboard/investment/export/i-investment.model';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { IConfiguration } from 'src/app/domain/model/configuration';
import { SessionService } from '../../session';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';
import { RootService } from 'src/app/domain/service/root/index';

@Injectable()
export class MyInvestmentService {
  /**
   *
   */
  constructor(
    private proxy: MyInvestmentProxy,
    private sessionService: SessionService,
    private rootService: RootService
  ) {}

  GetMyInvestments(
    start: Date,
    end: Date,
    displayclosedaccounts: boolean,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<IAccount[]> {
    return this.proxy
      .GetMyInvestments(
        start,
        end,
        displayclosedaccounts,
        accounts,
        this.rootService.viewDataForAllInvestors
      )
      .pipe(
        map((items) => {
          items.forEach((item) => {
            if (item.balance) {
              if (item.balance.navs) {
                item.balance.navs.forEach((n) => {
                  if (n.date) {
                    n.date = new Date(n.date);
                  }
                });
              }
            }
          });
          return items;
        })
      );
  }

  GetMyInvestmentsConfig() {
    return this.proxy.GetMyInvestmentsConfig();
  }

  GetBalances(
    start: Date,
    end: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ) {
    return this.proxy.GetBalances(
      start,
      end,
      accounts,
      this.rootService.viewDataForAllInvestors
    );
  }

  GenerateExportUrl(
    investments: IInvestment[],
    start: Date,
    end: Date,
    accounts: IDtoAccountGroup.IAccountItem[],
    groupKey: number,
    type: number
  ) {
    return this.proxy.GenerateExportUrl(
      investments,
      start,
      end,
      accounts,
      groupKey,
      this.rootService.viewDataForAllInvestors,
      type
    );
  }

  UpdateMyInvestmentDisplayClosedAccounts(config: IConfiguration<boolean>) {
    if (this.sessionService.isShadow()) {
      return this.proxy.getShadowUserDefaultObservable();
    } else {
      return this.proxy.UpdateMyInvestmentDisplayClosedAccounts(config);
    }
  }

  GetMyDealInvestments(
    start: Date,
    end: Date,
    displayclosedaccounts: boolean,
    accounts: IDtoAccountGroup.IAccountItem[],
    dealId: number
  ): Observable<IAccount[]> {
    return this.proxy.GetMyDealInvestments(
      start,
      end,
      displayclosedaccounts,
      accounts,
      this.rootService.viewDataForAllInvestors,
      dealId
    );
  }

  GetMyInvestments2023(
    start: Date,
    end: Date,
    displayClosedAccounts: boolean,
    accounts: IDtoAccountGroup.IAccountItem[]
  ) {
    return this.proxy.GetMyInvestments2023(
      start,
      end,
      displayClosedAccounts,
      accounts,
      this.rootService.viewDataForAllInvestors
    );
  }
}
